import styled from "styled-components";

const Header = styled.header`
  margin: 0 0 128px 0;
`;

export { Header };
